import React from "react";
import TableItem from "items/table/table";
import PaginatorContainer from "items/paginator/paginator-container";
import { StandartButton } from "commons/form-controls";
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';

const AdminChangelog = (props) => {
    const createChangelogRecord = () => {
        props.showRightMenu("create");
    }

    const addItemButton = !props.isTopicAccounts ? <StandartButton 
        icon={PlusIcon} 
        fill={'white'}
        title={props.getValue("ADD_CHANGELOG_RECORD")}
        callback={createChangelogRecord}
    /> : null

    const getTableHeader = (headers) => {
        return headers.map(k => props.getValue(k));
    }

    return (
        <div>
            <PaginatorContainer />
            { <TableItem 
                                    data={[getTableHeader(props.tableHeader), props.data]} 
                                    getValue={props.getValue} 
                                    addItemButton={addItemButton}
                                    height={415}
                                    //weekDays={props.weekDays}
                                    //hidden={props.deviceType === 'mobile' ? [3,4] : []}
                                    //hiddenInEdit={[4]}
            />}
        </div>
    )
}

export default AdminChangelog;